import type { TFunction } from 'i18next';

const CELL =
  'height:18px;overflow:hidden;padding:0px 3px;vertical-align:middle;';
const HEAD_CELL = `${CELL}background-color:rgb(231, 230, 230);font-weight:bold;text-align:center;`;
const TOTAL_CELL = `${CELL}background-color:#ececec;`;
const ROW_COUNT = 6;

const border = (index: number, lastIndex: number, bottom: string) =>
  [
    index === 0 ? 'border-left:1px solid #000000;' : '',
    `border-right:1px ${index === lastIndex ? 'solid' : 'dotted'} #000000;`,
    `border-bottom:1px ${bottom} #000000;`,
  ].join('');

/** 바닐라코 상품 출고 신청(66) 기본 본문 — 레거시 양식 3종(중국·미국법인, 해외영업)의 열을 합친 표 1종, 작성자 언어로 채움 */
export const buildBcoPartsContent = (t: TFunction): string => {
  const headers = [
    'NO',
    t('자재코드'),
    t('자재명'),
    t('요청수량'),
    t('운영가능월'),
    t('출고요청일'),
    t('수출 거래처'),
    t('비고'),
  ];
  const lastIndex = headers.length - 1;

  const unitRow = headers
    .map(
      (_, index) =>
        `<td style="${CELL}border-bottom:1px solid #000000;${
          index === lastIndex ? 'text-align:right;' : ''
        }">${
          // ':' 가 i18next ns 구분자로 해석되는 것 방지
          index === lastIndex ? t('(단위:EA)', { nsSeparator: false }) : ''
        }</td>`,
    )
    .join('');
  const headRow = headers
    .map(
      (header, index) =>
        `<td style="${HEAD_CELL}${border(
          index,
          lastIndex,
          'dotted',
        )}">${header}</td>`,
    )
    .join('');
  const bodyRows = Array.from({ length: ROW_COUNT }, (_, row) =>
    headers
      .map(
        (_, index) =>
          `<td style="${CELL}${border(index, lastIndex, 'dotted')}${
            index === 0 ? 'text-align:center;' : ''
          }">${index === 0 ? row + 1 : ''}</td>`,
      )
      .join(''),
  );
  const totalRow = [
    `<td colspan="3" style="${TOTAL_CELL}${border(
      0,
      lastIndex,
      'solid',
    )}font-weight:bold;text-align:center;">TTL</td>`,
    ...headers
      .slice(3)
      .map(
        (_, offset) =>
          `<td style="${TOTAL_CELL}${border(
            offset + 3,
            lastIndex,
            'solid',
          )}"></td>`,
      ),
  ].join('');

  const rows = [unitRow, headRow, ...bodyRows, totalRow]
    .map((cells) => `<tr style="height:18px;">${cells}</tr>`)
    .join('');
  const cols = [60, 120, 160, 100, 110, 110, 130, 110]
    .map((width) => `<col width="${width}">`)
    .join('');

  return [
    `<p style="text-align: center;">${t(
      '상기의 건에 대하여 아래와 같이 진행하오니 검토 후 결재 바랍니다.',
    )}</p>`,
    '<p><br></p>',
    `<p style="text-align: center;">${t('-아래-')}</p>`,
    '<p><br></p>',
    `<table cellspacing="0" cellpadding="0" style="table-layout:fixed;font-size:13px;"><colgroup>${cols}</colgroup><tbody>${rows}</tbody></table>`,
    '<p><br></p>',
    `<p>${t('기타의견')} : </p>`,
  ].join('');
};
